import {useParams} from "react-router-dom";
import {FormComponentV2} from "./Components/FormComponentV2";
import {Page} from "../../Common/Component/Page/Page";

export const FormPageV2 = () => {

    const {entity, id} = useParams();

    return <Page><FormComponentV2 entity={entity} id={id}/> </Page>

}
